import { FC, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Container,
  Box,
  Grid,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import Plus from "../../assets/images/plus.svg";
import Minus from "../../assets/images/minus-icon.svg";
import { FAQStyle } from "../Styles/LandingStyles";
import faqs from "../../utils/constants/faq";

const HomeFAQ: FC = () => {
  const [open, setOpen] = useState(100);
  const classes = FAQStyle();

  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpen = (index: number) => {
    if (open === index) {
      setOpen(100);
    } else {
      setOpen(index);
    }
  };
  return (
    <>
      <Container>
        <Box mb={10}>
          <Box textAlign={"center"} mt={10} mb={7.5}>
            <Typography
              component="span"
              className="aspekta-semiBold hero-blue "
              style={{ fontSize: isActive ? "28px" : "40px" }}
              >
              Frequently Asked Questions
            </Typography>
          </Box>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            {faqs.map((faq, index) => {
              return (
                <Grid item sm={10} md={5} key={index}>
                  <Accordion
                    className={classes.lockAccordion}
                    onClick={() => handleOpen(index)}
                    style={{
                      background:
                        open !== index ? "transparent" : "rgba(34, 219, 181, 0.15)",
                      boxShadow: "none",
                      border: "none",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        open !== index ? (
                          <img src={Plus} alt="" />
                        ) : (
                          <img src={Minus} alt="" />
                        )
                      }
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className={classes.lockAccordionSummary}
                    >
                      <Typography
                        variant="h3"
                        className="font-family-Poppin fw-normal"
                        style={{ fontSize: "20px", marginLeft: "15px" }}
                        component="h3"
                      >
                        {faq.question}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default HomeFAQ;
